import { Box, type BoxProps } from '@munifocus/ui';

export function Wrap({ sx, ...rest }: BoxProps) {
  return (
    <Box
      sx={{
        maxWidth: 1180,
        mx: 'auto',
        px: { xs: 3, md: 6 },
        ...sx,
      }}
      {...rest}
    />
  );
}
